import { z } from 'zod';

import { TypeProducer } from '../models/contentful-generated';
import { ContentfulAssetSchema } from './contentful-asset.validator';
import { ContentfulSysSchema } from './contentful-sys.validator';
import { LandingPageEntrySchema } from './landing-page.validator';
import { SeoMetadataEntrySchema } from './seo-metadata.validator';

export const ProducerEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    name: z.string(),
    slug: z.string(),
    logo: ContentfulAssetSchema.optional().nullable(),
    storefront: LandingPageEntrySchema.optional().nullable(),
    seoMetadata: SeoMetadataEntrySchema.optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});

export function validateProducerEntry(data: TypeProducer) {
  return ProducerEntrySchema.safeParse(data);
}

/**
 * Returns validation result.
 *
 * @param data
 */
export function validateProducerEntries(data: TypeProducer[]) {
  return z.array(ProducerEntrySchema).safeParse(data);
}

/**
 * Returns valid entries only. In most cases, this is preferred,
 * It allows us to still show some entries instead of showing nothing when only a single entry is invalid.
 *
 * @param data
 */
export function validateAndFilterProducerEntries(data: TypeProducer[]) {
  if (!data) return [];

  return data.reduce((acc: TypeProducer[], entry) => {
    const validationResult = validateProducerEntry(entry);
    if (validationResult.success) {
      acc.push(validationResult.data as unknown as TypeProducer);
    } else {
      console.warn(
        `Validation failed for producer entry with id: '${entry?.sys?.id}'. It will be filtered out. Error: ${validationResult.error.message}`
      );
    }
    return acc;
  }, []);
}
